import React, { useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
  Modal,
  Divider,
  IconButton,
} from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector } from "react-redux";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
  maxHeight: "80vh",
  overflowY: "auto",
};

const GlobalSearchFilter = ({ onApplyFilter, onClearFilter }) => {
  const postedJobsData =
    useSelector((state) => state?.jobs?.postedJobsData) || [];
  const jobs = postedJobsData?.posted_jobs || [];
  const initialDesignations =
    Array.from(new Set(jobs?.map((job) => job?.role))) || [];
  const initialSkills =
    Array.from(
      new Set(
        jobs.flatMap((job) =>
          typeof job?.skills === "string"
            ? job?.skills.split(",").map((skill) => skill.trim())
            : job?.skills || []
        )
      )
    ) || [];
  const initialLocations =
    Array.from(new Set(jobs?.map((job) => job?.location))) || [];
  
  const [open, setOpen] = useState(false);
  const [filters, setFilters] = useState({
    designation: [], // Initialize designation filter
    experience: [],
    skills: [],
    location: [],
    mode: [],
  });

  const filterOptions = {
    designation: initialDesignations,
    experience: [
      { label: "0-1 year", value: "0-12" },
      { label: "1-2 years", value: "12-24" },
      { label: "2-4 years", value: "24-48" },
      { label: "4-6 years", value: "48-72" },
      { label: "6-8 years", value: "72-96" },
      { label: "8-10 years", value: "96-120" },
      { label: "10+ years", value: "120-" },
    ],
    location: [
      ...new Set([
        ...initialLocations,
        "Bangalore",
        "Mumbai",
        "Delhi",
        "Hyderabad",
        "Chennai",
        "Pune",
        "Remote",
      ]),
    ],
    mode: ["Remote", "On-site", "Hybrid"],
    skills: [...new Set([...initialSkills])],
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleFilterChange = (category, value) => {
    setFilters((prev) => ({
      ...prev,
      [category]: prev[category]?.includes(value)
        ? prev[category]?.filter((item) => item !== value)
        : [...prev[category], value],
    }));
  };

  const handleApply = () => {
    const processedFilters = {
      ...filters,
      experience: filters.experience
        .map((exp) => {
          const range = filterOptions.experience.find(
            (o) => o.label === exp
          )?.value;
          if (!range) return null;
          const [min, max] = range.split("-");
          return {
            min_months: parseInt(min) || 0,
            max_months: max ? parseInt(max) : Number.MAX_SAFE_INTEGER,
          };
        })
        .filter(Boolean),
    };
    onApplyFilter(processedFilters);
    setOpen(false);
  };

  const handleClear = () => {
    setFilters({
      designation: [], // Clear designation filter
      experience: [],
      skills: [],
      location: [],
      mode: [],
    });
    onClearFilter();
    setOpen(false);
  };

  return (
    <>
      <IconButton onClick={handleOpen} sx={{ ml: 1 }}>
        <FilterAltIcon />
      </IconButton>

      <Modal open={open} onClose={handleClose} aria-labelledby="filter-modal">
        <Box sx={style}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography variant="h6">Candidates Filters</Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>

          {Object?.entries(filterOptions)?.map(([category, options]) => (
            <Box key={category} sx={{ mb: 3 }}>
              <Typography
                variant="subtitle1"
                sx={{ mb: 1, textTransform: "capitalize" }}
              >
                {category}
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                {category === "experience"
                  ? options.map((option) => (
                      <FormControlLabel
                        key={option.label}
                        control={
                          <Checkbox
                            checked={filters[category]?.includes(option.label)}
                            onChange={() =>
                              handleFilterChange(category, option.label)
                            }
                            size="small"
                          />
                        }
                        label={option.label}
                      />
                    ))
                  : options.map((option) => (
                      <FormControlLabel
                        key={option}
                        control={
                          <Checkbox
                            checked={filters[category]?.includes(option)}
                            onChange={() =>
                              handleFilterChange(category, option)
                            }
                            size="small"
                          />
                        }
                        label={option}
                      />
                    ))}
              </Box>
              <Divider sx={{ mt: 2 }} />
            </Box>
          ))}

          <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
            <Button variant="contained" onClick={handleApply} fullWidth>
              Apply Filters
            </Button>
            <Button variant="outlined" onClick={handleClear} fullWidth>
              Clear All
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default GlobalSearchFilter;